module.exports = __webpack_public_path__ + "static/media/Comic_IEEE.ace781a0.mp4";